const initialMeasures = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: 0,
  width: 0,
  x: 0,
  y: 0
};

export { initialMeasures };
//# sourceMappingURL=bundle.esm2.js.map
